import { addKeyMouseEvents, removeMouseEvents } from '@utils/key-mouse-event';
import { nextPage, prevPage, endPlay } from '../actions/control';
import store from '../store';

import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

type EventHandler = (e: Event) => void;
type EventConfig = Record<string, EventHandler>;

function handlerLast(): void {
    store.dispatch(prevPage());
}

function handlerNext(): void {
    store.dispatch(nextPage());
}

function handlerStop(): void {
    store.dispatch(endPlay());
}

function blockCtrlS(e: KeyboardEvent): void {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
}

let timer: NodeJS.Timeout | null = null;
let lastTimeStamp = 0;
let isMagicMouse = false;
function handleMouseWheel(event: WheelEvent): void {
    if (event.deltaY === 1 || event.deltaY === -1) {
        isMagicMouse = true;
    }
    if (isMagicMouse) {
        if (Math.abs(event.deltaY) < 32) return; // /灵敏度处理

        if (event.timeStamp > lastTimeStamp + 2000) {
            // /magic mouse 因为有回弹回掉需要持续1-1.5s 所以只能两秒之内只响应一次鼠标滚轮事件
            lastTimeStamp = event.timeStamp;
        } else {
            return;
        }
    } else if (event.timeStamp > lastTimeStamp + 500) {
        // /其它鼠标 所以只能500毫秒之内只响应一次鼠标滚轮事件
        lastTimeStamp = event.timeStamp;
    } else {
        return;
    }

    if (timer !== null) {
        clearTimeout(timer);
    }

    timer = setTimeout(() => {
        if (event.deltaY > 0) {
            handlerNext();
        } else {
            handlerLast();
        }
    }, 100);
}

/** 是否响应播放器快捷键 */
let shouldPlayerShortcutActive: (() => boolean) | undefined;

const wrapHandler = (eventHandler: EventHandler) => (e: Event) => {
    if (shouldPlayerShortcutActive && !shouldPlayerShortcutActive()) return;

    eventHandler(e);
};

const ctrl = browser.isMac || browser.isIPad ? 'command' : 'ctrl';
const configs: EventConfig = {
    left: wrapHandler(handlerLast),
    right: wrapHandler(handlerNext),
    up: wrapHandler(handlerLast),
    down: wrapHandler(handlerNext),
    esc: wrapHandler(handlerStop),
    enter: wrapHandler(handlerNext),
    space: wrapHandler(handlerNext),
    pagedown: wrapHandler(handlerNext),
    pageup: wrapHandler(handlerLast),
    backspace: wrapHandler(handlerLast),
};
const bubbleConfig: EventConfig = {
    [`${ctrl}+s`]: blockCtrlS,
    wheel: wrapHandler(handleMouseWheel),
};

/**
 * @param escBtnEnable 禁用 ESC 键
 * @param shouldShortcutActive prehook 检测是否应该响应播放快捷键
 */
export function registerEvents(escBtnEnable = true, shouldShortcutActive?: () => boolean): void  {
    shouldPlayerShortcutActive = shouldShortcutActive;

    if (escBtnEnable === false) {
        delete configs.esc;
    }

    // bubble:true 为了让keydown事件在冒泡阶段找到对应的回调
    addKeyMouseEvents(configs, { bubble: true });
    addKeyMouseEvents(bubbleConfig, { bubble: true });
}

export function unRegisterEvents(): void {
    shouldPlayerShortcutActive = undefined;

    removeMouseEvents(configs, { bubble: true });
    removeMouseEvents(bubbleConfig, { bubble: true });
}

export const testable = {
    configs,
    bubbleConfig,
    ctrl,
};
